/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Von rechts nach links",
		"timeZoneID": "Zeitzone",
		"skin": "Stil",
		"metricsFileImportTask": "Neuer Import aus Dateien",
		"displayMode": "Standardansicht",
		"credentialRenewed": "Ihre Berechtigungsnachweise wurden mit Ihrer aktuellen Benutzer-ID und Ihrem aktuellen Kennwort verlängert.",
		"productLocale": "Produktsprache",
		"toggleDisabled": "Inaktiv",
		"credentialChange": "Verlängern",
		"log_level_Debug": "Fehlerbehebung",
		"confirmNewPassword": "Neues Kennwort bestätigen",
		"unsavedViewMsg2": "Die Änderungen gehen verloren, wenn Sie sie nicht zuvor speichern.",
		"supportPortalErrorMessage": "Wiederholen Sie die Aktion.  Wenn das Problem weiterhin auftritt, wenden Sie sich an den Administrator.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, das IBM Logo, ibm.com und Cognos sind Marken oder eingetragene Marken der International Business Machines Corporation in den USA und/oder anderen Ländern. Eine aktuelle Liste der IBM Marken finden Sie auf der Webseite www.ibm.com/legal/copytrade.shtml. Dieses Programm unterliegt den Bedingungen der Lizenzvereinbarung, die mit dem Programm ausgeliefert wird. Diese Lizenzvereinbarung kann in einem Programmverzeichnisordner oder in einer Bibliothek namens \"License\" oder \"Non_IBM_License\" gespeichert sein oder in gedruckter Form bereitgestellt werden. Lesen Sie diese Lizenzvereinbarung bitte sorgfältig durch, bevor Sie das Programm verwenden. Wenn Sie das Programm verwenden, stimmen Sie diesen Bedingungen zu.",
		"groupsAndRoles": "Gruppen und Rollen",
		"metricsMaintenanceTask": "Neue Verwaltung",
		"email": "E-Mail",
		"contextual": "Kontextbezogen",
		"resetHome": "Auf Standard zurücksetzen",
		"ltr": "Von links nach rechts",
		"credentials": "Berechtigungsnachweise",
		"logging_congfig_title": "Protokollierung",
		"changePasswordTitle": "Kennwort ändern",
		"format": "Berichtsformat",
		"showUnread": "Nicht gelesene anzeigen",
		"AILearning_active": "AI-Learning ist aktiv:",
		"docsErrorMessage": "Wiederholen Sie die Aktion.  Wenn das Problem weiterhin auftritt, wenden Sie sich an den Administrator.",
		"toggleEnabled": "Aktiv",
		"homeSetError": "Beim Festlegen der Standardstartseite ist ein Fehler aufgetreten; schließen Sie diese Ansicht und öffnen Sie sie erneut.",
		"passwordChange": "Kennwort ändern",
		"profile": "Profil",
		"pdfRestricted": "PDF (eingeschränkt)",
		"drillThrough": "Drillthrough-Definitionen",
		"homeSet": "Die Startseite wurde erfolgreich festgelegt.",
		"regionalOptions": "Regionale Optionen",
		"myPreferences": "Eigene Vorgaben",
		"defaultHome": "Standard",
		"version": "Version",
		"controller": "Controller",
		"manage": "Verwalten",
		"biDirectionalFeaturesEnabled": "Unterstützung bidirektionaler Sprachen",
		"newFeaturesErrorTitle": "Der Link zu den neuen Features ist fehlgeschlagen.",
		"passwordMatch": "Kennwortabgleich",
		"updateProfileAndsettings": "Profil und Einstellungen aktualisieren",
		"dashboardConsole": "Arbeitsbereich",
		"legacyAppsSlideoutLabel": "Verfügbare traditionelle Anwendungen",
		"logging_config_description": "Die Protokollierung wird zur Fehlerbehebung genutzt. Beim Administrator erhalten Sie eine Anleitung zu den Einstellungen.",
		"confirmDeletion": "Löschen bestätigen",
		"signInButtonText": "Anmelden",
		"dataSourceCredentials": "Berechtigungsnachweise für Datenserver",
		"AILearningConfigurationSlideoutAllyLabel": "AI-Learning-Konfiguration",
		"loadingSettings": "Laden der Einstellungen",
		"spreadsheetMLRestricted": "Excel (eingeschränkt)",
		"manageAILearning": "AI-Learning",
		"xlsxDataRestricted": "Excel-Daten (eingeschränkt)",
		"advanced": "Erweiterte Optionen",
		"ok": "OK",
		"changeEmail": "Ändern",
		"showHints": "Hinweise anzeigen",
		"general": "Allgemein",
		"xlsxData": "Excel-Daten",
		"newPassword": "Neues Kennwort",
		"hideAll": "Alle ausblenden",
		"confirmPassword": "Kennwort bestätigen",
		"AILearning_config_description": "Sie können produktinterne Empfehlungen verbessern, indem Sie es Cognos Analytics ermöglichen, Informationen zu Ihrer Nutzung zu analysieren.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Der Link zum Support Portal ist fehlgeschlagen.",
		"log_level_Warn": "Warnung",
		"contentSettings": "Inhaltseinstellungen",
		"setHomeButton": "Festlegen",
		"myCapabilities": "Eigene Funktionen",
		"homePage": "Startseite",
		"helpErrorMessage": "Wiederholen Sie die Aktion.  Wenn das Problem weiterhin auftritt, wenden Sie sich an den Administrator.",
		"loadingProfile": "Laden des Profils",
		"portal": "Portal",
		"metricsPackage": "Neues Package",
		"myCredentials": "Eigene Berechtigungsnachweise",
		"credentialCreate": "Erstellen",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Aktualisieren des Kennworts nicht möglich",
		"showHiddenObjects": "Ausgeblendete Einträge anzeigen",
		"csv": "CSV",
		"docsErrorTitle": "Der Link zur Dokumentation ist fehlgeschlagen.",
		"log_level_Error": "Fehler",
		"wrongPassword": "Authentifizierung nicht möglich",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Information",
		"welcomeBanner": "Begrüßungsbanner",
		"helpErrorTitle": "Der Link zur Hilfefunktion ist fehlgeschlagen.",
		"contentLocale": "Inhaltssprache",
		"pdf": "PDF",
		"oldPassword": "Altes Kennwort",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Eingabehilfefunktionen",
		"manageLogging": "Protokollierung",
		"loggingConfigurationSlideoutA11yLabel": "Konfiguration der Protokollierung",
		"communityErrorTitle": "Der Link zur Community ist fehlgeschlagen.",
		"companionApps": "Begleitanwendungen",
		"setHomeLabel": "Startseite festlegen als (aktuelle Ansicht)",
		"metricsExportTask": "Neuer Export",
		"csvRestricted": "CSV (eingeschränkt)",
		"newFeaturesErrorMessage": "Wiederholen Sie die Aktion.  Wenn das Problem weiterhin auftritt, wenden Sie sich an den Administrator.",
		"contributor": "Contributor",
		"showAll": "Alle anzeigen",
		"logging_active": "Protokollierung aktiviert:",
		"html": "HTML",
		"profileAndSettings": "Profil und Einstellungen",
		"baseTextDirection": "Basisrichtung für Text",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Kennwort",
		"invalidEmail": "Gültige E-Mail-Adresse eingeben",
		"credentialCreateSuccess": "Sie haben Ihre Berechtigungsnachweise erfolgreich erstellt.",
		"settings": "Einstellungen",
		"restrictedFormatSelected": "Sie verfügen nicht über die Funktion zum Ausführen von Berichten in diesem Format, Sie können jedoch auf Berichte zugreifen, die in diesem Format gespeichert sind.",
		"usageDataDeletionConfirmation": "Durch das Löschen der Nutzungsdaten wird das AI-Learning zurückgesetzt.  Sollen die Nutzungsdaten tatsächlich gelöscht werden?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Details anzeigen",
		"deleteUsageData": "Nutzungsdaten löschen:",
		"showPassword": "Kennwort anzeigen",
		"AILearning_config_title": "AI-Learning",
		"myPreferencesSlideoutLabel": "Profil und Einstellungen",
		"passWordChangeSuccess": "Kennwort wurde erfolgreich geändert",
		"logging_level": "Protokollierungsstufe:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Wiederholen Sie die Aktion.  Wenn das Problem weiterhin auftritt, wenden Sie sich an den Administrator.",
		"cancel": "Abbrechen",
		"shareSetError": "Diese Aktion kann erst ausgeführt werden, nachdem diese Ansicht geschlossen und erneut geöffnet wurde.",
		"passwordNotMatch": "Kennwort stimmt nicht überein",
		"xml": "XML",
		"xmlRestricted": "XML (eingeschränkt)",
		"openMenu": "Menü öffnen",
		"closeMenu": 'Menü schließen'
});